import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';
import { createUseStyles } from 'react-jss';

const styles: ComponentStylesProps<number> = {
  content: {
    paddingBottom: '5rem',
  },
  tableWrapper: {
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    overflow: 'hidden',
  },
  infoWrapper: {
    display: 'flex',
    marginBottom: '5rem',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  tableHeader: {
    boxSizing: 'border-box',
  },
  tableHeading: {
    padding: '1.6rem 1rem',
    '&:first-child': {
      paddingLeft: '3.3rem',
    },
    '&:last-child': {
      paddingRight: '3.3rem',
    },
  },
  groupsCountText: {
    textAlign: 'right',
    font: {
      size: '1.6rem',
    },
    lineHeight: '1.8rem',
    marginBottom: '2rem',
  },
  groupsCount: {
    marginLeft: '1rem',
  },
  templateName: {
    margin: '0 0.5rem',
    color: colors.neutral[900],
  },
  templateInputName: {
    padding: '0 1.2rem 3.6rem 1.2rem',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
